import { createContext, createRef, useContext } from 'react';
import {
  FALLBACK_CURRENT_SLIDE_INDEX,
  FALLBACK_SLIDE_COUNT,
} from '../../const';
import { ContextValue } from './types';

/**
 * @todo добавить константу для noop-функци
 */
export const Context = createContext<ContextValue>({
  slideCount: FALLBACK_SLIDE_COUNT,
  setSlideCount: () => {
    //
  },

  currentSlideIndex: FALLBACK_CURRENT_SLIDE_INDEX,
  setCurrentSlideIndex: () => {
    //
  },

  scrollerRef: createRef(),

  slideRefsMap: createRef(),
  createSlideRef: () => () => {
    //
  },

  scrollTo: () => {
    //
  },
});

export const useContextForExternal = () => {
  const { slideCount, currentSlideIndex, setCurrentSlideIndex } =
    useContext(Context);

  return { slideCount, currentSlideIndex, setCurrentSlideIndex };
};
